import React from 'react'
import './SectionTitle.scss'

interface SectionTitleProps {
    title: string
    subtitle?: string
}

export const SectionTitle:React.FC<SectionTitleProps> = ({title, subtitle}) => {
    return (
        <div className='SectionTitle container mt-4'>
            <div className="title mb-3">{title}</div>
            <div className="subtitle col-12 col-md-8 mb-5">{subtitle}</div>
        </div>
    )
}

